// extracted by mini-css-extract-plugin
export default {"statistic":"Credit_statistic__No+Ch","block":"Credit_block__+AdbM","creditsList":"Credit_creditsList__5wMoD"};